import React from 'react';
import SocialMediaCluster from '../../Miscs/SocialMediaCluster/SocialMediaCluster';

const HeaderSocialMedia = () => {
	return (
		<>
			<div className="social-media">
				<ul>
					<SocialMediaCluster />
				</ul>
			</div>
		</>
	);
};

export default HeaderSocialMedia;
